/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ateliere_Connect_Status_Importing_CaptionInputs */

const en_ateliere_connect_status_importing_caption = /** @type {(inputs: Ateliere_Connect_Status_Importing_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importing caption file: ${i?.name}...`)
};

const fr_ateliere_connect_status_importing_caption = /** @type {(inputs: Ateliere_Connect_Status_Importing_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importation du fichier de sous-titres : ${i?.name}...`)
};

const de_ateliere_connect_status_importing_caption = /** @type {(inputs: Ateliere_Connect_Status_Importing_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importiere Untertiteldatei: ${i?.name}...`)
};

const it_ateliere_connect_status_importing_caption = /** @type {(inputs: Ateliere_Connect_Status_Importing_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione del file didascalia: ${i?.name}...`)
};

const ru_ateliere_connect_status_importing_caption = /** @type {(inputs: Ateliere_Connect_Status_Importing_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Импорт файла субтитров: ${i?.name}...`)
};

const es_ateliere_connect_status_importing_caption = /** @type {(inputs: Ateliere_Connect_Status_Importing_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importando archivo de subtítulos: ${i?.name}...`)
};

const zh_cn2_ateliere_connect_status_importing_caption = /** @type {(inputs: Ateliere_Connect_Status_Importing_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在导入字幕文件：${i?.name}...`)
};

const ja_ateliere_connect_status_importing_caption = /** @type {(inputs: Ateliere_Connect_Status_Importing_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`キャプションファイルをインポートしています: ${i?.name}...`)
};

const hi_ateliere_connect_status_importing_caption = /** @type {(inputs: Ateliere_Connect_Status_Importing_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कैप्शन फ़ाइल आयात की जा रही है: ${i?.name}...`)
};

const pt_pt2_ateliere_connect_status_importing_caption = /** @type {(inputs: Ateliere_Connect_Status_Importing_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importando arquivo de legenda: ${i?.name}...`)
};

/**
* | output |
* | --- |
* | "Importing caption file: {name}..." |
*
* @param {Ateliere_Connect_Status_Importing_CaptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_importing_caption = /** @type {((inputs: Ateliere_Connect_Status_Importing_CaptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Importing_CaptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_status_importing_caption(inputs)
	if (locale === "de") return de_ateliere_connect_status_importing_caption(inputs)
	if (locale === "it") return it_ateliere_connect_status_importing_caption(inputs)
	if (locale === "ru") return ru_ateliere_connect_status_importing_caption(inputs)
	if (locale === "es") return es_ateliere_connect_status_importing_caption(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_status_importing_caption(inputs)
	if (locale === "ja") return ja_ateliere_connect_status_importing_caption(inputs)
	if (locale === "hi") return hi_ateliere_connect_status_importing_caption(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_status_importing_caption(inputs)
	return en_ateliere_connect_status_importing_caption(inputs)
});